<header>
  <div class="grid-container" [ngStyle]="{'background-color': background, 'color': color}">
    <div class="govuk-width-container">
      <div class="govuk-main-wrapper">
        <div class="logo">
          <ng-container>  
            <span role=img [attr.aria-label]="urlLink">
              <img *ngIf="logo" class="img" [src]="logo" [attr.aria-label]="'logo'" (click)="goTo(urlLink)">
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div>
      <!-- {{headerText}} -->
    </div>

    <div *ngIf="this.enableTranslation">
      <div class="translate-wrap" aria-hidden="true">
        <div id="google_translate_element"></div>
      </div>
    </div>
    <div *ngIf="this.languageForm && this.enableTranslation" style="vertical-align: middle ">

      <div *ngIf="!showLanguageDropdown" class="customSelect">
        <span style="width:80%;">
          <button #languageButton *ngIf="showFlag(language)" class="butwid">
            <img src='{{showFlag(language)}}' class="flagStyle">
            <span class="notranslate langButtonStyle">{{language.Native}} </span>
          </button>
        </span>
      </div>

      <div *ngIf="showLanguageDropdown" class="customSelect dropdown" #languageDropdownEl>
        <span *ngFor="let l of languages" style="width:80%; background-color: white;">
          <button (click)="change_language(l)" class="selectButtons butwid">
            <img src='{{showFlag(l)}}' class="flagStyle">
            <span class="notranslate langButtonStyle">{{l.Native}} </span>
          </button>
          <br>
        </span>
      </div>
    </div>
  </div>
</header>